import APIServices from './APIServices'

// Cache para evitar requests duplicadas
let providersCache: Record<string, unknown> | null = null
let cacheTimestamp = 0
const CACHE_DURATION = 5 * 60 * 1000 // 5 minutos

export const getProviders = async (params: {
  page?: number
  per_page?: number
  search?: string
  type?: string
}) => {
  // Si es una búsqueda vacía y tenemos cache válido, usar cache
  if (
    !params.search &&
    providersCache &&
    Date.now() - cacheTimestamp < CACHE_DURATION
  ) {
    return providersCache
  }

  const cleanParams = Object.fromEntries(
    Object.entries(params || {}).filter(([, value]) => value != null)
  )
  const finalParams = { ...cleanParams, type: 'PROVIDER' }

  const response = await APIServices.get('/cargo/company', {
    params: finalParams,
  })

  const items = response.data?.items || []

  // Si es búsqueda vacía, guardar en cache
  if (!params.search) {
    providersCache = items
    cacheTimestamp = Date.now()
  }

  return items
}

export const getImporters = async (params: {
  page?: number
  per_page?: number
  search?: string
  type?: string
}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params || {}).filter(([, value]) => value != null)
  )
  const finalParams = { ...cleanParams, type: 'IMPORTER' }
  const response = await APIServices.get('/cargo/company', {
    params: finalParams,
  })
  return response.data?.items || []
}

export const getTransporters = async (params: {
  page?: number
  per_page?: number
  search?: string
  type?: string
}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params || {}).filter(([, value]) => value != null)
  )
  const finalParams = { ...cleanParams, type: 'TRANSPORTER' }
  const response = await APIServices.get('/cargo/company', {
    params: finalParams,
  })
  return response.data?.items || []
}

export const getStorages = async (params: {
  page?: number
  per_page?: number
  search?: string
  type?: string
}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params || {}).filter(([, value]) => value != null)
  )
  const finalParams = { ...cleanParams, type: 'STORAGE' }
  const response = await APIServices.get('/cargo/company', {
    params: finalParams,
  })
  return response.data?.items || []
}

export const getManagers = async (params: {
  page?: number
  per_page?: number
  search?: string
  type?: string
}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params || {}).filter(([, value]) => value != null)
  )
  const finalParams = { ...cleanParams, type: 'MANAGER' }
  const response = await APIServices.get('/cargo/company', {
    params: finalParams,
  })
  return response.data?.items || []
}

// Cache para suppliers
let suppliersCache: Record<string, unknown> | null = null
let suppliersCacheTimestamp = 0

export const getSuppliers = async (params: {
  page?: number
  per_page?: number
  search?: string
}) => {
  // Si es una búsqueda vacía y tenemos cache válido, usar cache
  if (
    !params.search &&
    suppliersCache &&
    Date.now() - suppliersCacheTimestamp < CACHE_DURATION
  ) {
    return suppliersCache
  }

  const cleanParams = Object.fromEntries(
    Object.entries(params || {}).filter(([, value]) => value != null)
  )

  const response = await APIServices.get('/administration/supplier', {
    params: cleanParams,
  })

  const items = response.data?.items || []

  // Si es búsqueda vacía, guardar en cache
  if (!params.search) {
    suppliersCache = items
    suppliersCacheTimestamp = Date.now()
  }

  return items
}
